import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { QuestionCircle, ArrowLeft, Search } from 'react-bootstrap-icons';

interface RESectionHeaderProps {
  title: string;
  backTo?: string;
  showHelp?: boolean;
  children?: React.ReactNode;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
}

export default function RESectionHeader({
  title,
  backTo,
  showHelp = true,
  children,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search Kross Global',
}: RESectionHeaderProps) {
  const navigate = useNavigate();
  const [localSearch, setLocalSearch] = useState('');
  const isControlled = searchValue !== undefined && onSearchChange;
  const search = isControlled ? searchValue : localSearch;
  const handleSearchChange = (value: string) => {
    if (onSearchChange) onSearchChange(value);
    else setLocalSearch(value);
  };

  return (
    <div className="bg-white border-bottom flex-shrink-0 p-3">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div className="d-flex align-items-center gap-2">
          {backTo != null && (
            <Button
              variant="outline-secondary"
              size="sm"
              aria-label="Back"
              onClick={() => navigate(backTo)}
              style={{ fontSize: '0.7rem', padding: '0.2rem 0.4rem' }}
            >
              <ArrowLeft size={14} />
            </Button>
          )}
          <h5 className="mb-0 me-3">{title}</h5>
        </div>
        <div className="d-flex align-items-center gap-2">
          <InputGroup size="sm" style={{ width: '200px' }}>
            <InputGroup.Text style={{ backgroundColor: 'white', borderRight: 'none', fontSize: '0.75rem' }}>
              <Search size={14} />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder={searchPlaceholder}
              value={search}
              onChange={(e) => handleSearchChange(e.target.value)}
              style={{ borderLeft: 'none', fontSize: '0.75rem' }}
              size="sm"
            />
          </InputGroup>
          {children}
          {showHelp && (
            <Button
              variant="outline-secondary"
              size="sm"
              aria-label="Help"
              style={{ fontSize: '0.7rem', padding: '0.2rem 0.4rem' }}
            >
              <QuestionCircle size={14} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
